import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { login, } from '../../store/modules/authSlice';
import { Button, Card, Modal, Theme, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import loginLogo from '../../assets/images/loginLogo.png'
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { consts } from '../../common/consts'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import { ReactComponent as SMALogo } from '../../assets/svgs/smalogo.svg';
import AusOperatedLogo from '../../assets/images/AO-logo.png'

import footerLogo from '../../assets/svgs/login/footer-logo.svg'
import { amountActiveSessionExceeded } from '../../common/phrases';
import { signIn } from './loginHelpers';
import AusMadeLogo from '../../assets/svgs/login/aus-made-logo.svg'




interface LoginWidgetProps extends React.Props<any> {
    finishLogin(isSuccess: boolean, token: string): void,
    goToForgotPassword(): void,
    goToLoginOTP(username: string, password: string, isSMS: boolean): void
};

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
}

function ElevationScroll(props: Props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}



const useStyles = makeStyles((theme: Theme) => ({
    root: {

    },

    inputs: {
        fontSize: 14,
    },

    button: {
        minWidth: 200,
        backgroundColor: '#FFB500',
        color: '#ffffff',
        borderRadius: 30,
        marginBottom: 40,
        '&:hover': {
            color: '#0049a3',
            backgroundColor: '#FFFFFF',
        },
    },
    link: {
        color: '#F5F5F5',
        paddingLeft: 0,
        fontSize: 'small'
    },
    logoImg: {
        display: 'block',
        marginTop: 20,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 374.67,
    },
    logoRoot: {
        height: 212
    },
    alertErrorRoot: {
        marginBottom: 20,
    },
    textFieldRoot: {
        width: '100%',
        marginBottom: 20,
        '& .MuiOutlinedInput-root': {

            '&:hover fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        borderRadius: '5px',
    },

    textFieldInput: {
        backgroundColor: '#ffffff',
        color: '#666666',
        borderRadius: '0px',
    },

    logo: {
        width: 200,
        height: 180,
    },
    navbar: {
        height: 142,
        display: 'flex',
        alignContent: 'center',
        position: 'sticky',
        justifyContent: 'center',
    },
    background: {
        backgroundColor: '#001630',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-03-1.jpg)',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    header: {
        justifyContent: 'center',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-02.png)',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        opacity: '1',
        transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s',
        display: 'flex',
        padding: '350px 0px 300px 0px',
    },
    widgetHeadings: {
        fontSize: 35,
        fontWeight: 800,

    },
    widgetBody: {
        fontSize: 16,
        fontWeight: 600,
    },
    contentContainer: {
        maxWidth: 1700,
        margin: 'auto',
        width: "-webkit-fill-available",
        paddingLeft: 50,
        paddingRight: 50,
    },
    headerBody: {
        display: 'flex',
    },
    widgetContent: {
        padding: 40,
        textAlign: 'center',
    },
    icon: {
        width: '70px',
        height: '70px',
    },
    menuBody: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    menu: {
        fontWeight: 700,
        fontSize: '16px',
        color: '#FFF',
        padding: '20px',
        '&:hover': {
            color: '#FFB500',
            textDecorationThickness: '3px',
            textUnderlineOffset: '10px'
        },
    },

    body: {
        display: 'flex',
        justifyContent: 'center'
    },
    widgets: {
        display: 'flex',
        alignContent: 'space-between',
        alignItems: 'space-between',
        justifyContent: 'space-between',
    },
    yAdjustment: {
        '--translateY': '-147.9px',
        transform: 'translateY(var(--translateY))',
    },
    widget: {
        backgroundColor: '#FFB500',
        borderRadius: '20px',
        width: '32%',
        maxWidth: '32%',
        textAlign: 'center',
    },
    headerLogin: {
        flexGrow: 1,
    },
    headerHeading: {
        flexGrow: 2,
        alignSelf: 'center',
    },
    heading: {
        fontSize: '100px',
        color: '#FFFFFF',
        fontWeight: 800,
        lineHeight: '1.2em',
        margin: 0,
        alignSelf: 'center',
    },
    loginHeaderButton: {
        backgroundColor: '#FFB500',
        borderRadius: 30,
        padding: '12px 30px',
        fontSize: 14,
        fontWeight: 800,
        '&:hover': {
            color: '#0049a3',
            backgroundColor: '#FFFFFF',
        },
    },
    loginText: {
        color: '#ffffff',

    },
    bodyHeading: {
        fontSize: 50,

    },
    aboutArea: {
        marginTop: 150,
    },
    h3: {
        fontSize: 30,
    },
    p: {
        fontSize: 20,
    },
    emailLink: {
        color: '#5292d1',
        textDecoration: 'none',
    },
    loginBodyButton: {
        backgroundColor: '#FFB500',
        borderRadius: 30,
        padding: '12px 30px',
        fontSize: 14,
        fontWeight: 800,
        '&:hover': {
            color: '#fff',
            backgroundColor: '#0049a3',
        },
    },
    bodyDivider: {
        borderRight: '2px solid #5292d1',
    },
    divider: {
        height: 120,
        backgroundColor: 'transparent',
        backgroundImage: 'linear-gradient(180deg, #0049A300 0%, #0049A352 100%)',
        opacity: '0.5',
        marginBottom: 100,
    },
    partners: {
        paddingTop: 40,
        paddingBottom: 40,
        display: 'flex',
        justifyContent: 'space-evenly'
    },
    andMore: {
        backgroundColor: '#ffb500'
    },
    footericons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        textAlign: 'center',
        flexWrap: 'wrap',
    },
    iconCaption: {
        fontSize: 22,
        fontWeight: 600,
        color: '#0049A3',
    },
    iconContainer: {
        width: '25%',
        maxWidth: '25%',
    },
    footer: {
        backgroundColor: '#001630',
        minHeight: 300,
        display: 'flex',
        textAlign: 'center',
    },
    footerLogo: {
        width: '269px',
    },
    footerLink: {
        color: '#fff',
        padding: 20,
        cursor: 'pointer',
        fontWeight: 'bold',
        '&:hover': {
            color: '#FFB500',
        },
    }
}));

function NewlineText(props: any) {
    const text = props.text;
    return <div style={{ whiteSpace: 'pre-wrap' }}>{text}</div>;
}


function LoginWidget(props: LoginWidgetProps): JSX.Element {
    const { handleSubmit, errors, control, formState, trigger, watch } = useForm();
    const preventDefault = (event: { preventDefault: () => any; }) => event.preventDefault();
    const history = useHistory();
    const dispatch = useDispatch();
    const classes = useStyles();

    const [errorMessage, setErrorMessage] = useState("");

    const [showPassword, setShowPassword] = useState(false);

    const TermsPage = () => {

        history.push('/terms-and-conditions');
    }

    const PrivacyPage = () => {

        history.push('/privacy');
    }

    const LoginPage = () => {

        history.push('/login');
    }



    const handleSignIn = async (data: any) =>{
        await signIn(
            data,
            dispatch,
            props.finishLogin,
            props.goToLoginOTP,
            setErrorMessage
        );
    }

    const handleClickShowPassword = () => {

        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const emailValue = watch("email", "");
    React.useEffect(() => {
        if (/[0-9]+/.test(emailValue)) {
            trigger();
        }
    }, [emailValue])

    return (
        <React.Fragment>
            <div className={classes.root}>
                <ElevationScroll {...props}>
                    <AppBar color='transparent' style={{ boxShadow: 'none' }}>
                        <Toolbar className={classes.navbar}>
                            <div className={classes.contentContainer} style={{ width: '-moz-available' }}>
                                <div className={classes.menuBody}>
                                    <SMALogo className={classes.logo} onClick={LoginPage} style={{ cursor: 'pointer' }}/>
                                    <div className={classes.menu}>
                                        <Button variant="contained" color="primary" className={classes.loginHeaderButton}>
                                            Login
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Toolbar>
                    </AppBar>
                </ElevationScroll>

                <section style={{ backgroundImage: 'linear-gradient(180deg, #0016308C 0%, #00163000 100%)', backgroundColor: "transparent", position: 'fixed', width: '100%', height: '142px' }}>
                </section>

                <section className={classes.background}>
                    <div className={classes.header}>
                        <div className={classes.contentContainer} style={{ width: '-moz-available' }}>
                            <Grid spacing={3} className={classes.headerBody} container>
                                <Grid item xs={8} className={classes.headerHeading}>
                                    <h1 className={classes.heading}>
                                        Privacy
                                    </h1>
                                </Grid>
                                <Grid item xs={4} className={classes.headerLogin}>
                                    <form onSubmit={handleSubmit(handleSignIn)} id="login-box" >
                                        <h2 className={classes.loginText}>Login</h2>
                                        <div className={classes.inputs}>
                                            <Controller
                                                defaultValue=''
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined' placeholder='Email Address / Employee Id' error={errors.email} helperText={errors.email ? errors.email.message : ""} />}
                                                name='email'
                                                rules={{
                                                    required: "Email Address / Employee Id is required",
                                                    pattern: {
                                                        value: consts.EmailEmployeeIDRegex,
                                                        message: "Invalid email address / employee id"
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className={classes.inputs}>
                                            <Controller
                                                defaultValue=''
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                                    classes: {
                                                        root: classes.textFieldInput
                                                    },
                                                    endAdornment: <InputAdornment position="end">
                                                        <IconButton style={{ color: '#fff' }}
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}>
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }} variant='outlined' placeholder='Password' type={showPassword ? 'text' : 'password'} error={errors.password} helperText={errors.password ? errors.password.message : ""} />}
                                                name='password'
                                                rules={{
                                                    validate: (value) => {
                                                        if (/[0-9]+/.test(emailValue))
                                                            return true;
                                                        else if (value === "")
                                                            return "Password is required";
                                                        return true;
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <Button onClick={() => props.goToForgotPassword()} className={classes.link}>
                                                Forgot your password?
                                            </Button>
                                        </div>
                                        <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertErrorRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                            <NewlineText text={errorMessage} />
                                        </Alert>
                                        <div className={classes.inputs}>
                                            <Button type='submit'
                                                disabled={formState.isSubmitting}
                                                className={classes.button}
                                                variant="contained">Sign In</Button>
                                        </div>
                                    </form>
                                 </Grid>
                            </Grid>
                        </div>
                    </div>
                </section>
                <section>
                    <div className={classes.contentContainer}>
                        <h1 style={{ fontSize: 50, lineHeight: '1.5', }}>State Medical Assistance - Privacy Policy</h1>
                        <p style={{ fontSize: 20, lineHeight: '1.5' }}>This Privacy Policy is maintained by STATE MEDICAL ASSISTANCE PTY LIMITED ACN 164 973 077 ("e", "us" and "our") and relates to the collection and use of personal information you may supply to us or we may collect from you through your dealings with us, including via access to any system or facility maintained by us or your conduct on any website maintained by us or through third parties.</p>
                        <p style={{ fontSize: 20, lineHeight: '1.5' }}>We recognise the importance of protecting the privacy of your information, in particular information that is capable of identifying an individual ("personal information") and we are committed to ensuring that we collect and use this personal information only in accordance with the Privacy Act 1988 and the Australian Privacy Principles (APPs). This Privacy Policy governs the manner in which your personal information will be dealt with including but not limited to collection, access, storage and use and disclosure of personal information which we obtain as part of our business operations. By accessing our website, systems, facilities or databases maintained by us or otherwise transacting with us, you agree to and acknowledge the content of this Privacy Policy. This Privacy Policy is in addition to any other terms and conditions applicable to our dealings with you, including any terms of use of our website.</p>
                        <p style={{ fontSize: 20, lineHeight: '1.5' }}>We reserve the right, at our discretion, to modify, add to or remove portions of this Privacy Policy at any time. We will notify you of any such variations or amendments by publishing the updated Privacy Policy on our website. You should review this Privacy Policy periodically so that you are updated on any changes. We welcome your comments and feedback.</p>
                        <p><strong>Personal Information</strong></p>
                        <ol><li>Personal information about you is collected only when knowingly and voluntarily submitted and when reasonably required by us to perform one or more of our functions or activities.</li><li>Personal information is collected by us or on our behalf via the following means: direct requests for information made by us to you either verbally or in writing, online and hard copy consent forms completed by you or on your behalf and service contracts including annexures or attachments thereto.</li><li>We may also collect personal information indirectly through third parties such as event promoters or your employer. We may also collect your personal information from other publicly available means or through websites (such as Google or social media sites) who disclose to their users that the user's personal information is provided to businesses such as ours. We may also collect or have access to personal information obtained by related entities to fulfil the purpose for which the personal information was collected, or a related or ancillary purpose or otherwise in accordance with the Privacy Act. We will do this only where you have consented to or would reasonably expect us to obtain this information.</li><li>It is our intention that this Policy will protect your personal information from being dealt with in any way that is inconsistent with applicable privacy laws in Australia including the APPs. The type of personal information that we may collect and hold includes:<br /><ol ><li>your name, address, contact details such as telephone numbers and email address;</li><li>your gender and date of birth;</li><li>bank account details; and</li><li>[include any other relevant information regularly collected]</li><li>other information that is necessary in the ordinary course of our business.</li></ol></li><li>We may also need to collect sensitive information from or relating to you where this is reasonably necessary for us to perform our services or we are otherwise authorised by law or court order to collect that information. Sensitive information is personal information that is given a higher level of protection under the APPs and may include information about your health (including genetic information) or biometric information, racial or ethnic origin, political opinions and memberships, religious or philosophical beliefs or affiliations, sexual orientation or criminal record.</li><li>Where it is reasonable and practical to do so we will only collect personal information about you from you. You have no obligation to provide any information requested by us however if you choose to withhold personal information from us it may prevent us from being able to provide you with the goods and/or services that you have requested.</li><li>We will take reasonable steps to ensure that your personal information is accurate, complete and up-to-date as soon as practicable after receiving your notification of any error or inaccuracy.</li></ol>
                        <p><strong><br />Provision of Personal Information about another person</strong></p>
                        <ol><li>You should only provide us with someone else's personal information if you have that person's authority or consent to provide us with their personal information. You should also take reasonable steps to inform them of the existence of and the matters set out in this Privacy Policy. If you provide us with someone else's personal information you promise to us that you have obtained the authority of and notified that person of this Privacy Policy.</li></ol>
                        <p><strong><br />Use of Information</strong></p>
                        <ol ><li>Personal information collected from you is used for the following purposes:<br /><ol type="a"><li>to progress an enquiry made by you;</li><li>to provide the services you have requested us to provide;</li><li>to provide service information and improve service delivery;</li><li>to process payments, discounts and refunds where required;</li><li>to manage your accounts with us;</li><li>to communicate with you regarding our products and services and to inform you of other relevant products and services we provide; and</li><li>to develop and expand our operations base and plan for future commitments.</li></ol></li><li>&nbsp;Direct marketing<br />We may also use your personal information for the purpose of marketing our services. If you do not want to receive marketing material from us, you can contact us as detailed below:<ul><li>For electronic communications, you can click on the "unsubscribe" function in the communication</li><li>For hard copy communications, you can email us at [insert]</li></ul></li><li>Personal information is held in paper archives, by electronic or computer data base and remotely in cloud based storage systems.</li></ol>
                        <p><strong><br />Disclosure</strong></p>
                        <ol ><li>We will not disclose your personal information unless you have consented to that disclosure. Your consent to disclosure of information other than sensitive information may be express or implied. Such disclosure may include to your treating medical professionals, insurers, contractors providing services to us such as IT services.</li><li>We may also disclose your personal information where it is required or authorised by or under an Australian law or a court/tribunal order or where a permitted general or health situation exists under the APPs. Where disclosure is necessary for an enforcement related activity of an enforcement agency, we will provide written notification of that disclosure as is required by the APPs.</li><li>Disclosure of sensitive information - We will only disclose any sensitive information that we may collect or hold about you for the purposes for which it was collected, or for directly related purposes you would reasonably expect us to use it for or if you have expressly consented to that disclosure or if we are otherwise authorised or compelled by law or a court order to disclosure that sensitive information.</li><li>We may engage third parties to provide you with goods or services on our behalf. In that circumstance, we may disclose your personal information to those third parties in order to meet your request for goods or services.</li><li>We do not presently disclose your personal information to recipients outside of Australia. However, in future, disclosure to overseas recipients may be necessary or desirable and we will update this Privacy Policy with details of those overseas recipients as required. You should review this Privacy Policy regularly to keep informed of any updates.</li><li>As part of provision of the services to you we may store your personal information using online software. The personal information that you provide to us may be transferred to the servers of our software providers as a function of transmission across the internet. By providing your personal information you are consenting to that personal information being transferred to and stored on the servers as set out in this Privacy Policy. However, as the third parties who host our servers do not control, and are not permitted to access or use your personal information (except for the limited purpose of storing the information), we do not "disclose" personal information to those server hosts, whether or not they are located overseas.</li><li>Notwithstanding the above, for the purpose of transparency we advise that the servers of our software providers are currently located in [insert location] however this location may change without prior notice to you. Your personal information may be routed through, and stored on, those servers. If the location of those servers changes in the future, we will update this Privacy Policy.</li><li>We will use reasonable endeavours to ensure that our server hosts do not have access to, and use the necessary level of protection to safeguard, your personal information and otherwise comply with the APPs. If you do not want your personal information to be transferred to a server in the location listed in the previous paragraph or to any other international locations, you should not provide us with your personal information or use our services.</li></ol>
                        <p><strong><br />Security</strong></p>
                        <ol ><li>We strive to ensure the security, integrity and privacy of personal information collected and held by us, and we review and update our security measures in light of current technologies. Unfortunately, we cannot guarantee that our data storage measures are totally secure.</li><li>However, we will endeavour to take all reasonable steps to protect the personal information we collect from you from misuse, interference, loss and unauthorised access, modification or disclosure.</li><li>In addition, our employees and the contractors who provide services related to our information systems are obliged to respect the confidentiality of any personal information held by us. However, we will not be held responsible for events arising from unauthorised access to or use of your personal information.</li><li>Where the personal information is no longer required for the purpose for which it was collected (or a permitted secondary purpose) we will take reasonable steps to destroy or de-identify the information.</li></ol>
                        <p><strong><br />IP Addresses</strong></p>
                        <ol ><li>If information is gathered by our website/portal or online database, our web servers may gather your IP address to assist with the diagnosis of problems or support issues with our services. This information is gathered in aggregate only and cannot be traced to an individual user.</li><li>Our website may contain links to third parties' websites, including sites maintained by related entities. Those other websites are not subject to this Privacy Policy and are not governed, managed or controlled by us. You should familiarise yourself and ensure you are comfortable with any particular privacy policies governing the use of those websites prior to such use.</li></ol>
                        <p><strong><br />Cookies and Applets</strong></p>
                        <ol ><li>We may use cookies to provide you with a better experience when using our website/portal. These cookies allow us to increase your security by storing your session ID and are a way of monitoring single user access. This aggregate, non-personal information is collated and provided to us to assist in analysing the usage of the site.</li></ol>
                        <p><strong><br />Access to Information</strong></p>
                        <ol><li>Depending on which services you are attempting to access, you may be able interact with us anonymously or using a pseudonym. However, this will mean that we may not be able to provide you with any services or the services to which you will have access will be limited.</li><li>We will endeavour to take all reasonable steps to keep information about you accurate and up to date. If, at any time, you discover that information held about you is incorrect, you may contact us to request the information is corrected. Further, you may request access to any of your personal information we hold. By law we may refuse to allow you access to information in certain circumstances including where giving access may pose serious threat to the health or safety of any person, or where it would have an unreasonable impact on the privacy of others. If we refuse to allow you access to your personal information held by us, we will explain why.</li><li>If you wish to make a complaint regarding any aspect of the collection, access to, use or storage of personal information by us, please make your complaint in writing to the address below. We will consider your complaint promptly and contact you to seek to resolve the matter. If we have not responded to you within a reasonable time, you are entitled under privacy legislation to make a complaint to the Office of the Australian Information Commissioner.</li><li>Please direct all requests for access to or correction of personal information or all complaints to: [insert]</li></ol>
                        <p><strong><br />How long is it held for?</strong></p>
                        <ol><li>Unless you specify an expiry date, we hold the information at a time of our own discretion.</li></ol>
                        <p><strong><br />Questions</strong></p>
                        <ol><li>For more information about privacy issues in Australia and protecting your privacy or to make a complaint about our handling of your personal information, visit the Office of the Australian Information Commissioner's web site; <span style={{ color: '#5292d1' }}><a style={{ color: '#5292d1'}} href="http://www.oaic.gov.au/">http://www.oaic.gov.au/</a></span>.</li></ol>

                    </div>
                </section>

                <section className={classes.footer}>
                    <div className={classes.contentContainer} style={{ width: '100%' }}>

                        <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'space-between' }}>

                            <div style={{ maxWidth: '300px', display: 'flex', textAlign: 'left', alignItems: 'center' }}>
                                <img src={AusOperatedLogo} style={{ width: 100, marginRight: 20, }} />
                                <a style={{ color: '#fff' }}>State Medical Assistance (SMA) is proudly 100% Australian owned</a>
                            </div>

                            <div style={{ width: "1px", height: "auto", backgroundColor: 'rgba(255, 255, 255, 0.15)' }}>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 300, textAlign: 'center', alignItems: 'center', }}>
                                <img src={footerLogo} className={classes.footerLogo} />
                                <a style={{ color: '#fff', marginTop: 10 }}>SMA Live is a product of State Medical Assistance</a>
                            </div>

                            <div style={{ width: "1px", height: "auto", backgroundColor: 'rgba(255, 255, 255, 0.15)' }}>
                            </div>

                            <div style={{ maxWidth: '300px', display: 'flex', textAlign: 'left', alignItems: 'center' }}>
                                <a style={{ color: '#fff' }}>SMA Live is proudly designed, developed and hosted in Australia</a>
                                <img src={AusMadeLogo} style={{ width: 100 }} />
                            </div>
                        </div>


                        <div style={{ marginTop: 40, paddingTop: 40, borderTop: "1px solid rgba(255, 255, 255, 0.15)" }}>
                            <a onClick={TermsPage} className={classes.footerLink} >Terms of Use</a>
                            <a onClick={PrivacyPage} className={classes.footerLink}>Privacy Policy</a>
                        </div>
                    </div>
                </section>
            </div>

        </React.Fragment >
    );
}

export default React.memo(LoginWidget)